module.exports = __webpack_public_path__ + "static/img/Woman Shoes.9fb4eb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/Woman Shoes.jpg
// module id = S82i
// module chunks = 1